import React from 'react';
import { Formik } from 'formik';
import commercePropTypes from '../../prop-types/commercePropTypes';
import commerceSchema from '../schema/commerceSchema';

var FormikWrapper = function FormikWrapper(_ref) {
  var children = _ref.children,
      onProductSubmit = _ref.onProductSubmit,
      availableStyles = _ref.availableStyles;
  var initialValues = {
    variantId: availableStyles[0].value,
    quantity: 1,
    chartUnit: 'centimeter'
  };
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validationSchema: commerceSchema,
    enableReinitialize: true,
    onSubmit: function onSubmit(values) {
      onProductSubmit(values);
    }
  }, children);
};

export default FormikWrapper;